import { takeEvery } from 'redux-saga/effects';

import { ComposedActions } from '../../helpers/actions';
import { GenericButtonClickBehaviour } from './executor.saga';

const onButtonClick = (actionType, canSkipValidation = false) => {
  return GenericButtonClickBehaviour({
    actionType: actionType,
    payloadTransformer: (payload: any) => [{ name: 'id', value: payload.id }],
    identifierPathsInExecPayload: {
      buttonId: 'actionPayload.id',
      window: 'actionPayload.window',
    },
    canSkipValidation,
  });
};

const onButtonClickWithValue = (actionType, key) => {
  return GenericButtonClickBehaviour({
    actionType: actionType,
    payloadTransformer: (payload: any) => ({
      id: payload.id,
      [key]: payload.value,
    }),
    identifierPathsInExecPayload: {
      buttonId: 'actionPayload.id',
      window: 'actionPayload.window',
    },
  });
};

const selectUnselectPhoneItemPayloadTransformer = (actionPayload: any) => {
  const { selectedPhoneNumber } = actionPayload;
  return {
    id: `ext_${selectedPhoneNumber[0].extension}`,
  };
};

const onSelectPhoneListItem = GenericButtonClickBehaviour({
  actionType: ComposedActions.TCTSelectPhoneListItem,
  payloadTransformer: (payload: any) => ({
    selectedPhoneNumber: [
      {
        extension: payload.id,
        row: payload.value,
        selected: payload.isSelected,
      },
    ],
  }),
  actionPayloadTransformer: (actionPayload: any) =>
    selectUnselectPhoneItemPayloadTransformer(actionPayload),
});

const actionWatcher = function* () {
  yield takeEvery(
    [
      ComposedActions.TCTMainWindowButtonClick.id,
      ComposedActions.TCTMainWindowButtonClick.uiAction,
    ],
    onButtonClick(ComposedActions.TCTMainWindowButtonClick)
  );
  yield takeEvery(
    [
      ComposedActions.TCTPhoneWindowDialPhone.id,
      ComposedActions.TCTPhoneWindowDialPhone.uiAction,
    ],
    onButtonClickWithValue(
      ComposedActions.TCTPhoneWindowDialPhone,
      'phoneNumber'
    )
  );
  yield takeEvery(
    [
      ComposedActions.TCTPhoneListWindowButtonClick.id,
      ComposedActions.TCTPhoneListWindowButtonClick.uiAction,
    ],
    onButtonClick(ComposedActions.TCTPhoneListWindowButtonClick)
  );
  yield takeEvery(
    [
      ComposedActions.TCTPhoneWindowButtonClick.id,
      ComposedActions.TCTPhoneWindowButtonClick.uiAction,
    ],
    onButtonClick(ComposedActions.TCTPhoneWindowButtonClick, true)
  );
  yield takeEvery(
    [
      ComposedActions.TCTSelectCommunicationUser.id,
      ComposedActions.TCTSelectCommunicationUser.uiAction,
    ],
    onButtonClick(ComposedActions.TCTSelectCommunicationUser)
  );
  yield takeEvery(
    [
      ComposedActions.TCTSelectPhoneListItem.id,
      ComposedActions.TCTSelectPhoneListItem.uiAction,
    ],
    onSelectPhoneListItem
  );
  yield takeEvery(
    [
      ComposedActions.TCTSettingsConfigWindowActivateCode.id,
      ComposedActions.TCTSettingsConfigWindowActivateCode.uiAction,
    ],
    onButtonClickWithValue(
      ComposedActions.TCTSettingsConfigWindowActivateCode,
      'code'
    )
  );
  yield takeEvery(
    [
      ComposedActions.TCTSettingsConfigWindowButtonClick.id,
      ComposedActions.TCTSettingsConfigWindowButtonClick.uiAction,
    ],
    onButtonClick(ComposedActions.TCTSettingsConfigWindowButtonClick, true)
  );

  yield takeEvery(
    [
      ComposedActions.TCTPhoneListClick.id,
      ComposedActions.TCTPhoneListClick.uiAction,
    ],
    onButtonClick(ComposedActions.TCTPhoneListClick)
  );

  yield takeEvery(
    [
      ComposedActions.TCTSettingsWindowButtonClick.id,
      ComposedActions.TCTSettingsWindowButtonClick.uiAction,
    ],
    onButtonClick(ComposedActions.TCTSettingsWindowButtonClick)
  );
};

export default actionWatcher;
